<template>
    <div class="row auctionsTab flex-fill">
        <div class="row h-100 text-center d-flex justify-content-center flex-grow-1">
            <div class="col-md-6 auctionTabHolder flex-fill d-flex flex-column">
                <div class="auctionsHeader">
                    <h4 class="title">
                        {{ $t('home.home_auction_title') }}
                        <b-button v-if="currentTab == 0 && user.mtsCustomer" @click="groupfilterToggle()"
                            :variant="filter ? 'secondary' : 'flat'" size="sm">
                            <i class="fas fa-filter"></i>
                        </b-button>
                    </h4>
                    <ul>
                        <li :class="currentTab == 0 ? 'active' : ''">
                            <a @click="loadData(0)">{{ $t('home.home_auction_tab_all') }}</a>
                        </li>
                        <li :class="currentTab == 1 ? 'active' : ''">
                            <a @click="loadData(1)">{{ $t('home.home_auction_tab_my') }}</a>
                        </li>
                        <li :class="currentTab == 2 ? 'active' : ''">
                            <a @click="loadData(2)">{{ $t('home.home_auction_tab_arhive') }}</a>
                        </li>
                    </ul>
                </div>
                <ul v-show="auctions.length" ref="auctionsList" class="auctionsList h-100">
                    <auction-list-item v-if="auctions.length > 0" v-for="a in auctions" :auction="a"
                        :currentTab="currentTab" :key="a.id" @updateAuction="onAuctionUpdate"></auction-list-item>
                </ul>
                <div v-if="!auctions.length"  class="d-flex flex-fill p-3">
                    <span class="text-primary m-auto" v-html="$t('home.home_auction_tab_all_no_data')"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'
import io from '../../socketio'
import AuctionListItem from './AuctionListItem.vue'

const AuctionsTab = Vue.component('auctions-tab', {
    components: {
        AuctionListItem,
    },

    props: {
        tab: 0,
    },

    data() {
        return {
            auctions: [],
            currentTab: -1,
            filter: false,
            page: 1,
            perPage: 25,
            loading: false,
            canLoadMore: true,
        }
    },

    methods: {
        btnSfx() {
            this.$store.dispatch('sound/sfx', 'Button')
        },

        loadData(tab, nextPage = false, silent = false) {
            let page = nextPage ? this.page + 1 : 1
            if (this.currentTab === tab && this.page === page && silent !== true) return
            if (silent !== true) this.btnSfx()

            if (this.loading) return

            if (page === 1) {
                this.auctions = []
                this.canLoadMore = true
            }

            if (page > 1 && !this.canLoadMore) return

            this.loading = true
            this.currentTab = tab

            let req = api.auctionsActive
            if (tab == 1) req = api.auctionsWon
            else if (tab == 2) req = api.auctionsFinished

            req({
                includeMtsCustomerCategory: this.filter && this.user.mtsCustomer ? this.user.mtsCustomerCategory.name : null,
                page: page,
                count: this.perPage,
            })
                .then((res) => {
                    this.page = page
                    if (res.data == undefined) res.data = []

                    this.canLoadMore = res.data.length === this.perPage

                    if (page == 1) this.auctions = res.data
                    else this.auctions = this.auctions.concat(res.data)
                })
                .catch((e) => {
                    api.baseErrorHendler(e)
                })
                .then((r) => {
                    this.loading = false
                })
        },

        onAuctionUpdate(data) {
            if (!data.id) return

            let searchIndex = this.auctions.findIndex((x) => x.id == data.id)
            if (searchIndex > -1) {
                Vue.set(this.auctions, searchIndex, data)
            }
        },

        scrollHandler() {
            const listElm = this.$refs.auctionsList
            // only first tab has more then one page (this.currentTab === 0 protect them from loading next page)
            if (this.currentTab === 0 && Math.ceil(listElm.scrollTop + listElm.clientHeight + this.page) >= listElm.scrollHeight) {
                this.loadData(this.currentTab, this.page + 1, true)
            }
        },

        updateFromRequestPopup(event) {
            this.loadData(this.currentTab, false, true)
        },

        groupfilterToggle() {
            this.filter = !this.filter
            this.loadData(this.currentTab, false, true)
        },
    },

    computed: {
        user() {
            return this.$store.state.auth.user
        },
    },

    created() {
        this.loadData(this.tab, false, true)
        io.io.on('AUCTION_UPDATE', this.onAuctionUpdate)
        this.$root.$on('updateAuctionRequest', this.updateFromRequestPopup)
    },

    mounted() {
        if (this.$refs.auctionsList) this.$refs.auctionsList.addEventListener('scroll', this.scrollHandler)
    },

    beforeDestroy() {
        document.getElementById('loader').classList.remove('show')
        io.io.off('AUCTION_UPDATE', this.onAuctionUpdate)
        this.$root.$off('updateAuctionRequest', this.updateFromRequestPopup)

        if (this.$refs.auctionsList) this.$refs.auctionsList.removeEventListener('scroll', this.scrollHandler)
    },
})

export default AuctionsTab
</script>
